import { AppService } from 'app/services/app.service';
import { AppFilter } from 'app/models/app-filter.model';

export abstract class AbAdminPreCadastro extends AppService {
  abstract getAllPreCadastrosInicio(filter: AppFilter);
}
